export default "__VITE_ASSET__0f840adb__"